<div class="link-up-container">
  <header>
    <pdq-heading element="h3">Link Up</pdq-heading>
    <pdq-button
      [icon]="operationSystem?.osIcon"
      variant="primary"
      [label]="'Download Link Up for ' + operationSystem?.name"
      (click)="downloadClient()"></pdq-button>
  </header>
  <div class="grid-container">
    <link-up-main [linkUp]="linkUp$ | async" [currentPdqUser]="currentPdqUser$ | async"></link-up-main>
    <link-up-workstations-list
      [workstations]="linkUpWorkstations$ | async"
      [currentPdqUser]="currentPdqUser$ | async"></link-up-workstations-list>
  </div>
</div>
